// 快讯接口
import { get } from '~/assets/js/api/methods'

import apiList from '~/api.config.js'
const { testwikidatacenter, homeClient } = apiList

export default axios => ({
  flashinit: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/live/7x24/index/init-v1`, params), // 快讯初始化
  flashmore: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/live/7x24/index/more-v1`, params), // 快讯更多 签名层
  flashUpward: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/live/7x24/index/latest-v1`, params) // 快讯最新 签名层
})
